
(function uiModuleDefinition() {

    angular.module("ui", []);

})();